import { Plugin, PluginKey } from '@tiptap/pm/state'
import { getAttributes } from '@tiptap/react'
import { commandKeyPressed } from '~/lib/command-key-pressed'

export interface ClickHandlerPluginProps {
  type: string
  pluginKey: string | PluginKey
  onClickInstance: (id: string) => void
}

export const BasehubMarkClickPlugin = (options: ClickHandlerPluginProps) => {
  return new Plugin({
    key:
      typeof options.pluginKey === 'string'
        ? new PluginKey(options.pluginKey)
        : options.pluginKey,
    props: {
      handleClick(view, pos, event) {
        if (event.button !== 0) {
          return false
        }

        const attrs = getAttributes(view.state, options.type)
        const domEl = event.target as HTMLElement

        const instanceId = domEl.getAttribute('id') ?? attrs.id
        if (!instanceId || !commandKeyPressed(event)) return false
        options.onClickInstance(instanceId)
        return false
      },
      handleDOMEvents: {
        pointerdown: (view, event) => {
          const attrs = getAttributes(view.state, options.type)
          const domEl = event.target as HTMLElement

          const instanceId = domEl.getAttribute('id') ?? attrs.id

          if (!instanceId || !commandKeyPressed(event)) return false
          options.onClickInstance(instanceId)
          return false
        },
      },
    },
  })
}
